import {Actions} from "egold/actions";
import {
    IBuyPrice,
    IGoldBalance, IGoldOrderStatus,
    IGoldProductDetails,
    IGoldTransactions,
    IPincodeDetails,
    IEgoldUserDetails, IVerifyGoldPrice, IVerifySellPrice,
    ISellPrice, IRedeemGoldDetails, ITransactionDetails, IDeliveryStatus,
} from "StateInterface";
import {ToastBgColor} from "egold/utils";

export interface IState {
    bankDetailsValidStatus: string;
    buyPrice: IBuyPrice;
    loading: boolean;
    sellPrice: ISellPrice;
    goldBalance: IGoldBalance;
    products: IGoldProductDetails[];
    pincodeDetails: IPincodeDetails;
    selectedProductIndex: number;
    transactions: IGoldTransactions[];
    invoiceLink: string;
    eGoldUserDetails: IEgoldUserDetails;
    orderStatus: IGoldOrderStatus;
    isRegisterModalOpen: boolean;
    verifyBuyPrice: IVerifyGoldPrice;
    toastDetails: {
        bgColor: string,
        msg: string,
    };
    paymentLink: string;
    redeemGoldDetails: IRedeemGoldDetails;
    verifySellPrice: IVerifySellPrice;
    transactionDetails: ITransactionDetails;
    verifyBankAccountDetails: any;
    isError: boolean;
    eligibleSellAmount: number;
    deliveryStatus: IDeliveryStatus;
}

const defaultState: IState = {
    bankDetailsValidStatus: null,
    loading: false,
    buyPrice: {
        applicable_tax: 0,
        current_price: 0,
        rate_id: 0,
        rate_validity: "",
    },
    sellPrice: {
        current_price: 0,
        rate_id: 0,
        rate_validity: "",
    },
    goldBalance: null,
    products: [],
    pincodeDetails: null,
    selectedProductIndex: null,
    transactions: [],
    invoiceLink: null,
    eGoldUserDetails: null,
    orderStatus: null,
    verifyBuyPrice: null,
    isRegisterModalOpen: false,
    toastDetails: {
        bgColor: "",
        msg: "",
    },
    paymentLink: null,
    redeemGoldDetails: null,
    transactionDetails: null,
    verifySellPrice: null,
    verifyBankAccountDetails: null,
    isError: false,
    eligibleSellAmount: null,
    deliveryStatus: null,
};

export default function eGold(state = defaultState, action) {
    switch (action.type) {
        case Actions.REQUEST_BUY_PRICE:
            return {
                ...state,
                loading: true,
                isError: false,
            };
        case `${Actions.REQUEST_BUY_PRICE}_SUCCESS`:
            return {
                ...state,
                loading: false,
                buyPrice: action.body,
            };
        case `${Actions.REQUEST_BUY_PRICE}_FAILURE`:
            return {
                ...state,
                loading: false,
                toastDetails: {
                    bgColor: ToastBgColor.RED,
                    msg: "Some error occurred!",
                },
            };
        case Actions.REQUEST_VERIFY_BUY_PRICE:
            return {
                ...state,
                loading: true,
                isError: false,
            };
        case `${Actions.REQUEST_VERIFY_BUY_PRICE}_SUCCESS`:
            return {
                ...state,
                loading: false,
                verifyBuyPrice: action.body,
            };
        case `${Actions.REQUEST_VERIFY_BUY_PRICE}_FAILURE`:
            return {
                ...state,
                loading: false,
                isError: true,
                toastDetails: {
                    bgColor: ToastBgColor.RED,
                    msg: action.body.error.message,
                },
            };
        case Actions.REQUEST_SELL_PRICE:
            return {
                ...state,
                loading: true,
                isError: false,
            };
        case `${Actions.REQUEST_SELL_PRICE}_SUCCESS`:
            return {
                ...state,
                loading: false,
                sellPrice: action.body,
            };
        case `${Actions.REQUEST_SELL_PRICE}_FAILURE`:
            return {
                ...state,
                loading: false,
                toastDetails: {
                    bgColor: ToastBgColor.RED,
                    msg: "Some error occurred!",
                },
            };
        case Actions.REQUEST_GET_BALANCE:
            return {
                ...state,
            };
        case `${Actions.REQUEST_GET_BALANCE}_SUCCESS`:
            return {
                ...state,
                loading: false,
                goldBalance: action.body,
            };
        case `${Actions.REQUEST_GET_BALANCE}_FAILURE`:
            return {
                ...state,
                loading: false,
                toastDetails: {
                    bgColor: ToastBgColor.RED,
                    msg: "Some error occurred!",
                },
            };
        case Actions.REQUEST_DELIVERY_PRODUCTS:
            return {
                ...state,
                loading: true,
                selectedProductIndex: null,
                pincodeDetails: null,
            };
        case `${Actions.REQUEST_DELIVERY_PRODUCTS}_SUCCESS`:
            return {
                ...state,
                loading: false,
                products: action.body.products,
            };
        case `${Actions.REQUEST_DELIVERY_PRODUCTS}_FAILURE`:
            return {
                ...state,
                loading: false,
                toastDetails: {
                    bgColor: ToastBgColor.RED,
                    msg: "Some error occurred!",
                },
            };
        case Actions.REQUEST_DELIVERY_PINCODE_CHECK:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_DELIVERY_PINCODE_CHECK}_SUCCESS`:
            return {
                ...state,
                loading: false,
                pincodeDetails: action.body,
            };
        case `${Actions.REQUEST_DELIVERY_PINCODE_CHECK}_FAILURE`:
            return {
                ...state,
                loading: false,
            };
        case Actions.REQUEST_TRANSACTIONS:
            return {
                ...state,
                loading: true,
                invoiceLink: null,
                orderStatus: null,
                deliveryStatus: null,
            };
        case `${Actions.REQUEST_TRANSACTIONS}_SUCCESS`:
            return {
                ...state,
                loading: false,
                transactions: action.body.transactions,
            };
        case `${Actions.REQUEST_TRANSACTIONS}_FAILURE`:
            return {
                ...state,
                loading: false,
            };
        case Actions.REQUEST_INVOICE:
            return {
                ...state,
                loading: true,
                invoiceLink: null,
            };
        case `${Actions.REQUEST_INVOICE}_SUCCESS`:
            return {
                ...state,
                loading: false,
                invoiceLink: action.body.invoice_link,
                toastDetails: {
                    bgColor: ToastBgColor.DARK,
                    msg: "Downloading",
                },
            };
        case `${Actions.REQUEST_INVOICE}_FAILURE`:
            return {
                ...state,
                loading: false,
                toastDetails: {
                    bgColor: ToastBgColor.RED,
                    msg: "Please try again !",
                },
            };
        case Actions.REQUEST_USER_DETAILS:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_USER_DETAILS}_SUCCESS`:
            return {
                ...state,
                loading: false,
                eGoldUserDetails: action.body,
            };
        case `${Actions.REQUEST_USER_DETAILS}_FAILURE`:
            return {
                ...state,
                loading: false,
            };
        case Actions.REQUEST_ORDER_STATUS:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_ORDER_STATUS}_SUCCESS`:
            return {
                ...state,
                loading: false,
                orderStatus: action.body,
            };
        case `${Actions.REQUEST_ORDER_STATUS}_FAILURE`:
            return {
                ...state,
                loading: false,
            };
        case Actions.REQUEST_REGISTER_USER:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_REGISTER_USER}_SUCCESS`:
            return {
                ...state,
                loading: false,
                eGoldUserDetails: action.body,
                isRegisterModalOpen: false,
                toastDetails: {
                    bgColor: ToastBgColor.GREEN,
                    msg: "User has been registered",
                },
            };
        case `${Actions.REQUEST_REGISTER_USER}_FAILURE`:
            return {
                ...state,
                loading: false,
                isRegisterModalOpen: false,
                toastDetails: {
                    bgColor: ToastBgColor.RED,
                    msg: action.body['isExist'] ? action.body.error.message : "Some error occurred!",
                },
            };
        case Actions.SELECTED_PRODUCT_INDEX:
            return {
                ...state,
                selectedProductIndex: action.body.productIndex,
            };
        case Actions.HIDE_TOAST:
            return {
                ...state,
                toastDetails: {
                    bgColor: "",
                    msg: "",
                },
            };
        case Actions.SHOW_REGISTER_MODAL:
            return {
                ...state,
                isRegisterModalOpen: true,
            };
        case Actions.HIDE_REGISTER_MODAL:
            return {
                ...state,
                isRegisterModalOpen: false,
            };
        case Actions.SHOW_TOAST:
            return {
                ...state,
                toastDetails: {
                    bgColor: action.body.bgColor,
                    msg: action.body.msg,
                },
            };
        case Actions.CLEAR_VERIFY_PRICE:
            return {
                ...state,
                verifyBuyPrice: null,
                verifySellPrice: null,
            };
        case Actions.REQUEST_PAYMENT_LINK:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_PAYMENT_LINK}_SUCCESS`:
            return {
                ...state,
                loading: true,
                paymentLink: action.body.url,
            };
        case `${Actions.REQUEST_PAYMENT_LINK}_FAILURE`:
            return {
                ...state,
                loading: false,
                toastDetails: {
                    bgColor: ToastBgColor.RED,
                    msg: "Some error occurred!",
                },
            };
        case Actions.REQUEST_REDEEM_GOLD:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_REDEEM_GOLD}_SUCCESS`:
            return {
                ...state,
                loading: false,
                redeemGoldDetails: action.body,
            };
        case `${Actions.REQUEST_REDEEM_GOLD}_FAILURE`:
            return {
                ...state,
                loading: false,
                toastDetails: {
                    bgColor: ToastBgColor.RED,
                    msg: "Some error occurred!",
                },
            };
        case Actions.REQUEST_TRANSACTIONS_STATUS:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.REQUEST_TRANSACTIONS_STATUS}_SUCCESS`:
            return {
                ...state,
                loading: false,
                transactionDetails: action.body,
            };
        case `${Actions.REQUEST_TRANSACTIONS_STATUS}_FAILURE`:
            return {
                ...state,
                loading: false,
                toastDetails: {
                    bgColor: ToastBgColor.RED,
                    msg: "Some error occurred!",
                },
            };
        case Actions.CLEAR_PAYMENT_LINK:
            return {
                ...state,
                paymentLink: null,
            };
        case Actions.REQUEST_VERIFY_SELL_PRICE:
            return {
                ...state,
                loading: true,
                verifySellPrice: null,
                isError: false,
            };
        case `${Actions.REQUEST_VERIFY_SELL_PRICE}_SUCCESS`:
            return {
                ...state,
                loading: false,
                verifySellPrice: action.body,
            };
        case `${Actions.REQUEST_VERIFY_SELL_PRICE}_FAILURE`:
            return {
                ...state,
                loading: false,
                isError: true,
                eligibleSellAmount: !action.body.error.allowedSellAmount  ? null : action.body.error.allowedSellAmount,
                toastDetails: !action.body.error.allowedSellAmount ? {bgColor: ToastBgColor.RED, msg: action?.body?.error?.message || "Some error occurred!"} : {bgColor: "", msg: ""},
            };
        case Actions.CLEAR_ELIGIBLE_SELL_AMOUNT:
            return {
                ...state,
                loading: false,
                isErro: false,
                eligibleSellAmount: null,
            }
        case Actions.REQUEST_VERIFY_BANK_ACCOUNT:
            return {
                ...state,
                loading: true,
                bankDetailsValidStatus: null,
            };
        case `${Actions.REQUEST_VERIFY_BANK_ACCOUNT}_SUCCESS`:
            return {
                ...state,
                loading: false,
                verifyBankAccountDetails: action.body,
                bankDetailsValidStatus: "SUCCESS",
            };
        case `${Actions.REQUEST_VERIFY_BANK_ACCOUNT}_FAILURE`:
            return {
                ...state,
                loading: false,
                bankDetailsValidStatus: "FAILED",
            };
        case Actions.UPDATE_VERIFIED_BANK_DETAILS:
            return {
                ...state,
                loading: false,
                eGoldUserDetails: {
                    ...state.eGoldUserDetails,
                    bankAccountDetails:{
                        bankAccount: action.body.bankAccount,
                        isPanVerified: action.body.isVerified,
                        panNameMatch: action.body.panNameMatch,
                    } 
                }
            }
        case Actions.REQUEST_DELIVERY_STATUS:
            return {
                ...state,
                loading: true,
                invoiceLink: null,
            };
        case `${Actions.REQUEST_DELIVERY_STATUS}_SUCCESS`:
            return {
                ...state,
                loading: false,
                deliveryStatus: action.body,
            };
        case `${Actions.REQUEST_DELIVERY_STATUS}_FAILURE`:
            return {
                ...state,
                loading: false,
                toastDetails: {
                    bgColor: ToastBgColor.RED,
                    msg: "Some error occurred!",
                },
            };
        case Actions.CLEAR_BANK_DETAILS_SUCCESS_RESPONSE:
            return {
                ...state,
                bankDetailsValidStatus: null,
            };
            case Actions.SET_KYC_STATUS:
            return {
                ...state,
                eGoldUserDetails: {
                    ...state.eGoldUserDetails,
                    panDetails: action.body,
                }
            }
        default:
            return state;
    }
}
